import { orderProductModalStore } from '../store/orderProductModalStore';
import { IResponseProductModifier, IResponseProductModifierOption } from 'src/types/products';
import { formatPrice, formatPriceSettings } from 'src/utils/formatter';
import { BUTTON_TITLE } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { IMessageModalProps, messagesStore } from '~/view/containers/Messages';

const _selectedOptionsCount = (options: IResponseProductModifierOption[]): number => {
  const count: number = options.reduce((_count: number, option: IResponseProductModifierOption) => {
    return option.selected ? _count + (option.quantity || 1) : _count;
  }, 0);

  return count;
};

export const validateMultiChoiceModifier = (modifier: IResponseProductModifier): boolean => {
  let valid: boolean = true;

  // get count of all selected options
  const count: number = _selectedOptionsCount(modifier.options);

  // maximum = 0 = infinity
  if (modifier.maximum && count > modifier.maximum) {
    // selected more of maximum options
    valid = false;
  } else if (count < modifier.minimum) {
    // selected less of minimum options
    valid = false;
  } else if (modifier.required && (!count || count < 0)) {
    // modifier is required
    valid = false;
  } else if (modifier.options.find((option) => option.quantity > option.maximum)) {
    valid = false;
  }

  return valid;
};

export const validateSingleChoiceModifier = (modifier: IResponseProductModifier): boolean => {
  let valid: boolean = true;

  // get count of all selected options
  const count: number = _selectedOptionsCount(modifier.options);

  if (!count && modifier.minimum > 0) {
    // minimum one option should be selected in single choise
    valid = false;
  } else if (count > 1) {
    // maximum one option should be selected in single choise
    valid = false;
  }

  return valid;
};

/**
 * Price formatting depending on currency_settings
 *
 * @see currencySettings
 * @see formatPrice
 * @param {(string | number)} price
 */
export const formatPriceInProduct = (price: string | number): string => {
  return orderProductModalStore.currencySettings ? formatPriceSettings(price, orderProductModalStore.currencySettings) : formatPrice(price);
};

export const showProductModalErrorMessage = (error: Pick<IMessageModalProps, 'title' | 'message'>) => {
  messagesStore.addMessage({
    title: error.title ? localeStore.t(error.title) : undefined,
    message: error.message ? localeStore.t(error.message) : undefined,
    contentClassName: 'message-popup-content_small',
    options: [{ title: localeStore.t(BUTTON_TITLE.CLOSE), appearance: 'tertiary', stretched: true }],
  });
};
